export const SET_MODE = "SET_MODE";
export const SET_COLOR = "SET_COLOR";
export const GET_THEME = "GET_THEME";
